import ReactGA from 'react-ga';

const useAnalyticsEventTracker = (category = 'golingo') => {
  const eventTracker = (
    action = 'no action passed',
    label = 'no label passed',
  ) => {
    // console.log(`category: ${category}`)
    // console.log(`action: ${action}`)
    // console.log(`label: ${label}`)
    ReactGA.event({ category, action, label });
  };
  return eventTracker;
};
export default useAnalyticsEventTracker;
